"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getTrending;
async function getTrending(config, size, type) {
    var _a;
    const clientId = config["CLIENT_ID"];
    // TRACK_BASE_URL is a bare host in most configs; without a scheme the browser would treat it as a relative path.
    const rawBase = (_a = config["TRACK_BASE_URL"]) !== null && _a !== void 0 ? _a : "";
    const baseUrl = /^https?:\/\//i.test(rawBase) ? rawBase : `https://${rawBase}`;
    const params = new URLSearchParams({
        clientId,
        size,
        type,
    });
    const url = `${baseUrl}/api/event/trending?${params.toString()}`;
    const response = await fetch(`${url}`);
    if (response) {
        const data = await (response === null || response === void 0 ? void 0 : response.json());
        return data;
    }
    return;
}
